function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1465_21925)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.50016 8.66536C7.69678 8.66536 8.66683 7.69532 8.66683 6.4987C8.66683 5.30208 7.69678 4.33203 6.50016 4.33203C5.30355 4.33203 4.3335 5.30208 4.3335 6.4987C4.3335 7.69532 5.30355 8.66536 6.50016 8.66536Z",
  stroke: "#8A8A8A",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.66684 4.3317V7.04003C8.66684 7.47101 8.83804 7.88433 9.14279 8.18908C9.44753 8.49382 9.86086 8.66503 10.2918 8.66503C10.7228 8.66503 11.1361 8.49382 11.4409 8.18908C11.7456 7.88433 11.9168 7.47101 11.9168 7.04003V6.49836C11.9168 5.27584 11.5031 4.08929 10.7432 3.13165C9.98326 2.17401 8.92172 1.50161 7.73118 1.22377C6.54065 0.945937 5.29113 1.07901 4.18581 1.60135C3.0805 2.1237 2.18438 3.00459 1.64318 4.1008C1.10198 5.197 0.947524 6.44405 1.20493 7.63917C1.46233 8.83429 2.11645 9.9072 3.06093 10.6834C4.0054 11.4597 5.18469 11.8936 6.40704 11.9146C7.62938 11.9356 8.82289 11.5425 9.7935 10.7992",
  stroke: "#8A8A8A",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1465_21925"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  fill: "white"
})));
function SvgAtSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSign);
export default __webpack_public_path__ + "static/media/at-sign.ff72c6d7804cbcad03ba357dbf83e49f.svg";
export { ForwardRef as ReactComponent };